const STORAGE_KEY = "packagingSku.selectedType"
const PACKAGE_TYPES = ["Shipping", "Primary"]

export function readPackagingSkuSelectedType() {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)
    return PACKAGE_TYPES.includes(value) ? value : "Shipping"
  } catch {
    return "Shipping"
  }
}

export function rememberPackagingSkuSelectedType(type) {
  if (!PACKAGE_TYPES.includes(type)) return
  try {
    sessionStorage.setItem(STORAGE_KEY, type)
  } catch {
    /* ignore */
  }
}

export function clearPackagingSkuSelectedType() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
